// extracted by mini-css-extract-plugin
export var main = "Layout-module--main--iEHMm";
export var page = "Layout-module--page--9O8CM";